(function () {
  'use strict';

  var SIZE_COLOR_MAP = {
    homee: {
      black: 'black-homee-medium-makeup-bag-designer-cosmetic-case',
      pink: 'pink-homee-medium-makeup-bag-designer-cosmetic-case-1',
      blush: 'blush-pink-homee-medium-makeup-bag-designer-beauty-case',
      silver: 'silver-homee-medium-makeup-bag-designer-cosmetic-case',
      white: 'white-homee-medium-makeup-bag-designer-cosmetic-case',
      // HOMEE itself doesn't come in burgundy. The MINEE Large is the
      // closest everyday/travel-sized burgundy piece in the catalog, so it
      // stands in for HOMEE when a shopper wants burgundy specifically.
      burgundy: 'minee-large-makeup-bag-burgundy'
    },
    bigee: {
      black: 'black-bigee-large-beauty-travel-case',
      pink: 'pink-bigee-large-beauty-travel-case',
      blush: 'blush-pink-bigee-large-beauty-travel-case',
      silver: 'silver-bigee-large-beauty-travel-case',
      white: 'white-bigee-large-beauty-travel-case',
      // Same substitution as HOMEE above — BIGEE has no burgundy colourway.
      burgundy: 'minee-large-makeup-bag-burgundy'
    }
  };

  var MINEE_MAP = {
    small: { burgundy: 'minee-small-makeup-bag', pink: 'minee-small-makeup-bag-pink' },
    medium: { burgundy: 'minee-medium-makeup-bag-burgundy', pink: 'minee-medium-makeup-bag-pink' },
    large: { burgundy: 'minee-large-makeup-bag-burgundy' },
    trio: { burgundy: 'new-minee-trio-burgundy-makeup-bag-set-bonus-brush-roll-holder' }
  };

  var BUNDLE_MAP = {
    'homee-bigee': 'bestseller-bundle',
    minee: { burgundy: 'minee-bundle', pink: 'minee-bundle-pink' },
    trio: 'new-minee-trio-burgundy-makeup-bag-set-bonus-brush-roll-holder'
  };

  var SIX_SWATCHES = [
    { val: 'black', label: 'Black', color: '#1f1f1f' },
    { val: 'pink', label: 'Pink', color: '#E0469B' },
    { val: 'blush', label: 'Blush Pink', color: '#E3B8BE' },
    { val: 'silver', label: 'Silver', color: '#B7B2AC' },
    { val: 'white', label: 'White', color: '#FFFFFF' }
  ];

  var TWO_SWATCHES = [
    { val: 'burgundy', label: 'Burgundy', color: '#5c1226' },
    { val: 'pink', label: 'Pink', color: '#E0469B' }
  ];

  var PROGRESS_MAP = {
    'q1': 10,
    'q2-color': 60,
    'q2-minee-amount': 45,
    'q3-minee-color': 75,
    'q2-bundle-choice': 45,
    'q3-bundle-minee-color': 75,
    'result': 100
  };

  var state = { answers: {} };
  var rootEl, progressEl, stageEl;
  var resultData = null;
  var resultLevel = 'full';

  function currentStep() {
    var a = state.answers;
    if (!a.category) return 'q1';
    if (a.category === 'homee' || a.category === 'bigee') {
      return a.color ? 'result' : 'q2-color';
    }
    if (a.category === 'minee') {
      if (!a.amount) return 'q2-minee-amount';
      if ((a.amount === 'small' || a.amount === 'medium') && !a.color) return 'q3-minee-color';
      return 'result';
    }
    if (a.category === 'bundle') {
      if (!a.bundleChoice) return 'q2-bundle-choice';
      if (a.bundleChoice === 'minee' && !a.color) return 'q3-bundle-minee-color';
      return 'result';
    }
    return 'q1';
  }

  function resolveDataKey() {
    var a = state.answers;
    if (a.category === 'homee') return SIZE_COLOR_MAP.homee[a.color];
    if (a.category === 'bigee') return SIZE_COLOR_MAP.bigee[a.color];
    if (a.category === 'minee') return MINEE_MAP[a.amount][a.color || 'burgundy'];
    if (a.category === 'bundle') {
      if (a.bundleChoice === 'homee-bigee') return BUNDLE_MAP['homee-bigee'];
      if (a.bundleChoice === 'minee') return BUNDLE_MAP.minee[a.color];
      if (a.bundleChoice === 'trio') return BUNDLE_MAP.trio;
    }
    return null;
  }

  function goBack() {
    var a = state.answers;
    if ('color' in a) { delete a.color; render(); return; }
    if ('amount' in a) { delete a.amount; render(); return; }
    if ('bundleChoice' in a) { delete a.bundleChoice; render(); return; }
    if ('category' in a) { delete a.category; render(); return; }
  }

  function esc(s) { return window.EstetikaWI.esc(s); }

  function optionsHTML(options, key) {
    return '<div class="eq-options">' + options.map(function (o) {
      return '<button type="button" class="eq-option" data-eq-option="' + o.val + '" data-eq-key="' + key + '">' +
        '<span class="eq-option-label">' + esc(o.label) + '</span>' +
        (o.sub ? '<span class="eq-option-sub">' + esc(o.sub) + '</span>' : '') +
        '</button>';
    }).join('') + '</div>';
  }

  function swatchesHTML(swatches, key) {
    return '<div class="eq-swatches">' + swatches.map(function (s) {
      var borderStyle = s.val === 'white' ? 'border:1px solid #ddd;' : '';
      return '<button type="button" class="eq-swatch" data-eq-option="' + s.val + '" data-eq-key="' + key + '">' +
        '<span class="eq-swatch-circle" style="background:' + s.color + ';' + borderStyle + '"></span>' +
        '<span class="eq-swatch-label">' + esc(s.label) + '</span>' +
        '</button>';
    }).join('') + '</div>';
  }

  function updateResultPieces() {
    var r = window.EstetikaWI.piecesHTML(resultData, resultLevel);
    var piecesEl = document.getElementById('eq-pieces');
    if (piecesEl) piecesEl.innerHTML = r.html;
    var countEl = document.getElementById('eq-count-num');
    if (countEl) countEl.textContent = r.total;
    var btns = stageEl.querySelectorAll('[data-wi-level]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', btns[i].getAttribute('data-wi-level') === resultLevel);
    }
  }

  function renderResultStep(backHTML) {
    var key = resolveDataKey();
    var data = window.EstetikaWI.DATA[key];
    if (!data) {
      stageEl.innerHTML = '<div class="eq-question"><p>Hmm, something went wrong finding your match.</p>' +
        '<button type="button" class="eq-retake-btn" data-eq-retake>Retake Quiz</button></div>';
      return;
    }
    if (!data.url) data.url = '/products/' + key;
    resultData = data;
    resultLevel = 'full';
    var isBundle = data.pieces.length > 1;

    var html = backHTML +
      '<div class="eq-result">' +
      '<div class="eq-result-photo"><img src="' + data.image + '" alt="' + esc(data.title) + '"></div>' +
      '<div class="eq-result-info">' +
      '<div class="eq-result-eyebrow">Your Perfect Match</div>' +
      '<h2 class="eq-result-title">' + esc(data.title) + '</h2>' +
      '<div class="eq-result-dims">' + esc(data.dims) + '</div>' +
      '<div class="eq-result-price">' + esc(data.price) + '</div>' +
      '<div class="wi-toolbar"><div class="wi-count"><strong id="eq-count-num">0</strong> real products that fit' + (isBundle ? ', across all pieces' : ' inside') + '</div>' +
      '<div class="wi-toggle"><button type="button" class="wi-toggle-btn is-active" data-wi-level="full">Full Travel Routine</button><button type="button" class="wi-toggle-btn" data-wi-level="light">Everyday Essentials</button></div></div>' +
      '<div class="wi-pieces' + (isBundle ? ' wi-pieces--bundle' : '') + '" id="eq-pieces"></div>' +
      '<div class="eq-result-actions">' +
      '<a class="eq-shop-btn" href="' + data.url + '">Shop Now</a>' +
      '<button type="button" class="eq-retake-btn" data-eq-retake>Retake Quiz</button>' +
      '</div>' +
      '<form class="eq-email" data-eq-email novalidate>' +
      '<div class="eq-email-heading">Want your match in your inbox?</div>' +
      '<p class="eq-email-sub">Optional. We will pop your pick in your inbox so you have it handy.</p>' +
      '<div class="eq-email-row">' +
      '<label class="eq-visually-hidden" for="eq-email-input">Your email</label>' +
      '<input class="eq-email-input" id="eq-email-input" type="email" name="email" placeholder="Your email" autocomplete="email" inputmode="email">' +
      '<button type="submit" class="eq-email-btn">Email me my match</button>' +
      '</div>' +
      '<div class="eq-email-msg" role="status" aria-live="polite"></div>' +
      '</form>' +
      '</div>' +
      '</div>';
    stageEl.innerHTML = html;
    updateResultPieces();
  }

  function render() {
    var step = currentStep();
    if (progressEl) progressEl.style.width = (PROGRESS_MAP[step] || 10) + '%';
    var backHTML = step !== 'q1' ? '<button type="button" class="eq-back" data-eq-back>← Back</button>' : '';

    if (step === 'result') {
      renderResultStep(backHTML);
      return;
    }

    var eyebrow, title, body;
    switch (step) {
      case 'q1':
        eyebrow = 'Find Your Perfect Match';
        title = 'What are you looking for?';
        body = optionsHTML([
          { val: 'homee', label: 'Everyday vanity essentials', sub: 'Medium size, for the bathroom bench' },
          { val: 'bigee', label: 'A full travel routine', sub: 'Large size, for longer trips' },
          { val: 'minee', label: 'Quick grab-and-go only', sub: 'Small pouches for the essentials' },
          { val: 'bundle', label: 'The complete system', sub: 'Two sizes, one complete routine' }
        ], 'category');
        break;
      case 'q2-color':
        eyebrow = 'Question 2 of 2';
        title = 'Pick your colour';
        body = swatchesHTML(SIX_SWATCHES, 'color');
        break;
      case 'q2-minee-amount':
        eyebrow = 'Question 2 of 3';
        title = 'How much are you packing?';
        body = optionsHTML([
          { val: 'small', label: 'Just the essentials', sub: 'Lipstick, powder, touch-ups — 23×8×15cm' },
          { val: 'medium', label: 'A full face of makeup', sub: 'Complete routine — 26×10×20cm' },
          { val: 'large', label: 'Hair tools too', sub: 'Straightener, hairspray — 32×12×23cm' },
          { val: 'trio', label: 'The whole system', sub: 'All three sizes + a brush roll holder' }
        ], 'amount');
        break;
      case 'q3-minee-color':
        eyebrow = 'Question 3 of 3';
        title = 'Pick your colour';
        body = swatchesHTML(TWO_SWATCHES, 'color');
        break;
      case 'q2-bundle-choice':
        eyebrow = 'Question 2';
        title = 'Which bundle?';
        body = optionsHTML([
          { val: 'homee-bigee', label: 'HOMEE + BIGEE', sub: 'Everyday + travel, one complete system — Pink' },
          { val: 'minee', label: 'MINEE Small + Medium', sub: 'The grab-and-go system' },
          { val: 'trio', label: 'MINEE Trio', sub: 'Small, Medium, Large + a brush roll holder — Burgundy' }
        ], 'bundleChoice');
        break;
      case 'q3-bundle-minee-color':
        eyebrow = 'Question 3 of 3';
        title = 'Pick your colour';
        body = swatchesHTML(TWO_SWATCHES, 'color');
        break;
    }

    stageEl.innerHTML = '<div class="eq-question"><div class="eq-eyebrow">' + eyebrow + '</div>' +
      '<h2 class="eq-question-title">' + title + '</h2>' + body + backHTML + '</div>';
  }

  function onClick(e) {
    var optBtn = e.target.closest('[data-eq-option]');
    if (optBtn) {
      var key = optBtn.getAttribute('data-eq-key');
      var val = optBtn.getAttribute('data-eq-option');
      state.answers[key] = val;
      render();
      return;
    }
    var backBtn = e.target.closest('[data-eq-back]');
    if (backBtn) { goBack(); return; }
    var retakeBtn = e.target.closest('[data-eq-retake]');
    if (retakeBtn) { state.answers = {}; render(); return; }
    var toggleBtn = e.target.closest('[data-wi-level]');
    if (toggleBtn && rootEl.contains(toggleBtn)) {
      resultLevel = toggleBtn.getAttribute('data-wi-level');
      updateResultPieces();
    }
  }

  var KLAVIYO_COMPANY_ID = 'UhYzGF';
  var KLAVIYO_LIST_ID = 'Y7TBG2';

  function onEmailSubmit(e) {
    var form = e.target.closest('[data-eq-email]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('.eq-email-input');
    var btn = form.querySelector('.eq-email-btn');
    var msg = form.querySelector('.eq-email-msg');
    var email = (input.value || '').trim();
    msg.className = 'eq-email-msg';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      msg.textContent = 'That email does not look quite right. Mind checking it?';
      msg.classList.add('is-error');
      input.focus();
      return;
    }
    if (form.getAttribute('data-busy') === '1') return;
    form.setAttribute('data-busy', '1');
    btn.disabled = true;
    msg.textContent = 'Sending...';
    var a = state.answers;
    var d = resultData || {};
    var handle = resolveDataKey() || '';
    var url = d.url || '';
    if (url && url.charAt(0) === '/') url = window.location.origin + url;
    var props = {
      quiz_name: 'Take our 10 second quiz',
      quiz_completed_at: new Date().toISOString(),
      quiz_category: a.category || '',
      quiz_colour: a.color || '',
      quiz_amount: a.amount || '',
      quiz_bundle_choice: a.bundleChoice || '',
      quiz_answers: JSON.stringify(a),
      quiz_match_name: d.title || '',
      quiz_match_handle: handle,
      quiz_match_url: url
    };
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Estetika quiz',
          profile: { data: { type: 'profile', attributes: {
            email: email,
            properties: props,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2025-01-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      form.classList.add('is-done');
      msg.className = 'eq-email-msg is-success';
      msg.textContent = 'Thank you! Your match is on its way to your inbox.';
      input.disabled = true;
    }).catch(function () {
      form.removeAttribute('data-busy');
      btn.disabled = false;
      msg.className = 'eq-email-msg is-error';
      msg.textContent = 'Sorry, we could not save your email just now. Please try again in a moment.';
    });
  }

  function mount() {
    if (!/\/pages\/take-our-10-second-quiz/.test(window.location.pathname)) return;
    if (document.getElementById('estetika-quiz-root')) return;
    if (!window.EstetikaWI) { setTimeout(mount, 50); return; }

    var anchor = document.querySelector('section[id*="177960163393c9a876"]') || document.getElementById('MainContent');
    var root = document.createElement('div');
    root.id = 'estetika-quiz-root';
    root.className = 'eq-root';
    root.innerHTML = '<div class="eq-progress"><div class="eq-progress-bar" id="eq-progress-bar" style="width:10%"></div></div><div class="eq-stage" id="eq-stage"></div>';

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(root, anchor.nextSibling);
    } else {
      document.body.appendChild(root);
    }

    rootEl = root;
    progressEl = document.getElementById('eq-progress-bar');
    stageEl = document.getElementById('eq-stage');
    rootEl.addEventListener('click', onClick);
    rootEl.addEventListener('submit', onEmailSubmit);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
